import React, { useEffect, useState } from "react";

import {
    Platform,
    Text,
    View
} from "react-native";
import NavBarButton from "./NavBarButton";
import { IcFilter } from "../../utils/Icons";
import AppTheme from "../../utils/Theme";
import Modal from "../../../specific/components/Modal/Modal";
import UserLevelSelection from "../Filters/UserLevelSelection";
import i18n from "../../utils/Localization/Localization";
import User from "../../data/user/User";
import { EventRegister } from "../../utils/EventListeners";
import { EventFiltersByLevelChanged, EventUserAuthDB } from "../../utils/Constants";

interface NavBarTitleProps {
    title: string;
    titleColor?: string;
    showLevel?: boolean;
}

const NavBarTitle = (props: NavBarTitleProps) => {

    const appTheme: AppTheme = new AppTheme();
    const user: User = User.getInstance();

    const [refresh, setRefresh] = useState<number>(0);

    const { title, showLevel = true, titleColor = appTheme.darkBlue } = props;

    useEffect(() => {
        EventRegister.addEventListener(EventFiltersByLevelChanged, (data) => {
            setRefresh(new Date().getTime());
        });
        return () => {
            EventRegister.removeEventListener(EventFiltersByLevelChanged);
        };
    }, []);

    const renderLevel = () => {
        if (showLevel === false) {
            return <View />
        }
        return  <Text style={{ color: titleColor, fontFamily: appTheme.primarySemiBoldFont, fontSize: appTheme.pixelPerfectForFont(7), textAlign: "center" }}>{i18n.t("levels." + user.children_level).toLocaleLowerCase()}</Text>
    }

    return <View style={{ width: appTheme.getFullAppWidth(), alignItems: "center", height: appTheme.pixelPerfect(60), justifyContent: "center" }}>
        <Text style={{ paddingHorizontal: appTheme.pixelPerfect(30), color: titleColor, fontFamily: appTheme.superHerosFontBold, fontSize: Platform.OS === "web" ? appTheme.pixelPerfectForFont(14) : appTheme.pixelPerfectForFont(11), textAlign: "center" }}>{title.toLocaleUpperCase()}</Text>
       {renderLevel()}
    </View>
}

export default NavBarTitle;